import React, { useState, useEffect } from 'react'
import '../Styles/Dashboard.css'
// import { LineChart } from '@mui/x-charts';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Thermometer from './Thermometer';
import LevelIndicator from "./LevelIndicator";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import { useLocation } from "react-router-dom";
import { getUserDetails } from '../Utility/AsyncStorage';
import { showToast } from './Toast';
import { format } from 'date-fns';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

function Dashboard() {

    const location = useLocation();
    const machineId = location.state;
    var userdetails = getUserDetails()

    const navigate = useNavigate();
    const valueFormatter = (value) => `${value}`;

    const [isDetailOpen, setIsDetailOpen] = useState(false);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);

    const [machineDetails, setMachineDetail] = useState({});
    const [notificationData, setNotificationData] = useState([]);
    const [data, setData] = useState([]);
    const [visualData, setVisualData] = useState([]);
    const [alarmCount, setAlarmCount] = useState(0);
    const [actualBatchData, setActualBatchData] = useState([])
    const [electricSpec, setElectricSpec] = useState([])
    const [graphAccDetails, setGraphAccDetails] = useState([])
    const [graphVelDetails, setGraphVelDetails] = useState([])
    const [machineState, setMachineState] = useState("white")
    const selectedToDate = (new Date())
    const [bladeData, setBladeData] = useState([])
    const [batchData, setBatchData] = useState([])
    const [rawData, setRawData] = useState([])
    const [updateRespData, setUpdateRespData] = useState(null)
    const [ackLoading, setAckLoading] = useState(false)




    const toggleDetails = () => {
        setIsDetailOpen(!isDetailOpen);
    };

    const closeProfile = (e) => {
        if (e.target.className === 'profile-overlay') {
            setIsDetailOpen(false);
            setIsNotificationOpen(false)
        }
    };

    const dashboardMachineData = async () => {
        try {
            let url = "https://itlapi.flovation.in/machine/fetchMachineDetails";
            let body = {
                machine_id: machineId
            }
            // console.log("dashboardMachineData", url, body)userdetails.access_token
            await axios.post(url, body, {
                headers: {
                    'authorization': `${userdetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {

                        // console.log("dashboardMachineData", response.data.list)
                        if (Object.keys(response.data.list).length !== 0) {
                            delete response.data.list[0].id
                            delete response.data.list[0].doa
                            delete response.data.list[0].is_active
                            delete response.data.list[0].machine_id

                            // console.log("dashboardMachineData", response.data.list)
                            setMachineDetail(response.data.list[0])
                        }
                    }
                    else {
                        console.log("dashboardMachineData", response.data.msg)
                    }

                } else {
                    console.log("dashboardMachineData error")
                }

            }).catch(error => {
                if (error.response.status === 403) {
                    console.log("dashboardMachineData if", error)
                    showToast("Session Time Out", 3000, "red");
                    navigate("/")
                }
                else
                    console.log("dashboardMachineData else", error)

            })
        } catch (error) {
            console.log("dashboardMachineData", error)
        }
    }

    const PLCData = async () => {
        try {
            let url = "https://itlapi.flovation.in/machine/fetchPlcData";
            let body = {
                machine_id: machineId
            }
            // console.log("PLCData", url, body)
            await axios.post(url, body, {
                headers: {
                    'authorization': `${userdetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {

                        console.log("rawData", response.data.list.rawData)
                        setData(response.data.list.data)
                        setVisualData(response.data.list.visualData)
                        setActualBatchData(response.data.list.actualBatchData)
                        setElectricSpec(response.data.list.electricalSpec)
                        setMachineState(response.data.list.machine_current_state)
                        setBladeData(response.data.list.bladeData)
                        setBatchData(response.data.list.batchData)
                        setRawData(response.data.list.rawData)
                    }
                    else {
                        console.log("PLCData", response.data.msg)
                    }

                } else {
                    console.log("PLCData error")
                }

            }).catch(error => {
                if (error.response.status === 403) {
                    console.log("PLCData if", error)
                    showToast("Session Time Out", 3000, "red");
                    navigate("/")
                }
                else
                    console.log("PLCData else", error)

            })
        } catch (error) {
            console.log("PLCData", error)
        }
    }

    const NotificationList = async () => {
        try {
            let url = "https://itlapi.flovation.in/machine/fetchAlarmDetails";
            let body = {
                machine_id: machineId
            }
            // console.log("NotificationList", url, body)
            await axios.post(url, body, {
                headers: {
                    'authorization': `${userdetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {
                        // setNotificationData(response.data.list[0])
                        const onCount = response.data.list[0].filter(item => item.value === 'ON');
                        // console.log("setNotificationData", onCount)
                        setNotificationData(onCount)
                        setAlarmCount(onCount.length)
                        // for(let key of response.data.list[0])
                        // console.log("NotificationList", key)
                    }
                    else {
                        console.log("NotificationList", response.data.msg)
                    }

                } else {
                    console.log("NotificationList error")
                }

            }).catch(error => {
                if (error.response.status === 403) {
                    console.log("NotificationList if", error)
                    showToast("Session Time Out", 3000, "red");
                    navigate("/")
                }
                else
                    console.log("NotificationList else", error)

            })
        } catch (error) {
            console.log("NotificationList", error)
        }
    }

    const GraphData = async () => {
        try {
            // setGraphAccDetails([])
            // setGraphVelDetails([])
            let url = "https://itlapi.flovation.in/machine/fetchMachineGraphData";
            let body = {
                machine_id: machineId
            }
            // GraphData.log("PLCData", url, body)
            await axios.post(url, body, {
                headers: {
                    'authorization': `${userdetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {
                        console.log("GraphData", response.data)
                        setGraphAccDetails(response.data.Acceleration_Data)
                        setGraphVelDetails(response.data.Velocity_Data)
                    }
                    else {
                        console.log("GraphData", response.data.msg)
                    }

                } else {
                    console.log("GraphData error")
                }

            }).catch(error => {
                if (error.response.status === 403) {
                    console.log("GraphData if", error)
                    showToast("Session Time Out", 3000, "red");
                    navigate("/")
                }
                else
                    console.log("GraphData else", error)

            })
        } catch (error) {
            console.log("GraphData", error)
        }
    }

    const fetchMachineUpdateResp = async () => {
        try {
            let url = "https://itlapi.flovation.in/machine/fetchMachineUpdateResp";
            let body = {
                machine_id: machineId
            }
            await axios.post(url, body, {
                headers: {
                    'authorization': `${userdetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {
                        console.log("fetchMachineUpdateResp", response.data)
                        if (response.data.list && response.data.list.length > 0) {
                            // don't clobber a popup that's already open / awaiting ack
                            setUpdateRespData((prev) => prev ?? response.data.list[0]);
                        }
                    }
                } else {
                    console.log("GraphData error")
                }

            }).catch(error => {
                if (error.response.status === 403) {
                    console.log("GraphData if", error)
                    showToast("Session Time Out", 3000, "red");
                    navigate("/")
                }
                else
                    console.log("GraphData else", error)

            })
        } catch (error) {
            console.log("GraphData", error)
        }
    }

    const ackMachineUpdateResp = async (device_id) => {
        try {
            let url = "https://itlapi.flovation.in/machine/ackMachineUpdateResp";
            let body = {
                machine_id: machineId
            }
            await axios.post(url, body, {
                headers: {
                    'authorization': `${userdetails.access_token}`
                },
            }).then(response => {

            }).catch(error => {
                if (error.response.status === 403) {
                    console.log("GraphData if", error)
                    showToast("Session Time Out", 3000, "red");
                    navigate("/")
                }
                else
                    console.log("GraphData else", error)

            })
        } catch (error) {
            console.log("GraphData", error)
        }
    }

    const handleAckUpdateResp = async () => {
        if (!updateRespData) return;
        setAckLoading(true);
        try {
            await ackMachineUpdateResp(updateRespData.device_id);
        } finally {
            setAckLoading(false);
            setUpdateRespData(null);
        }
    };

    useEffect(() => {
        const fetchData = () => {
            dashboardMachineData();
            PLCData();
            NotificationList();
            GraphData();
            fetchMachineUpdateResp();
        };

        fetchData();

        const interval = setInterval(fetchData, 10000);

        return () => clearInterval(interval);
    }, []);

    const MultiLineChartAcc = () => {
        return (
            <ResponsiveContainer width="100%" height={200}>
                <LineChart
                    data={graphAccDetails}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                >
                    <CartesianGrid strokeDasharray="4 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip /> {/* Shows data on hover */}
                    {/* <Legend /> */}
                    <Line type="monotone" dataKey="RMS Acceleration x-axis" stroke="#8884d8" strokeWidth={2} />
                    <Line type="monotone" dataKey="RMS Acceleration y-axis" stroke="#FF5733" strokeWidth={2} />
                    <Line type="monotone" dataKey="RMS Acceleration z-axis" stroke="#33FF57" strokeWidth={2} />
                </LineChart>
            </ResponsiveContainer>
        );
    };

    const MultiLineChartVel = () => {
        return (
            <ResponsiveContainer width="100%" height={200} backgroundColor="white">
                <LineChart
                    data={graphVelDetails}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                >
                    <CartesianGrid strokeDasharray="4 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip /> {/* Shows data on hover */}
                    {/* <Legend /> */}
                    <Line type="monotone" dataKey="RMS Velocity x-axis" stroke="#FF33A8" strokeWidth={2} />
                    <Line type="monotone" dataKey="RMS Velocity y-axis" stroke="#33A8FF" strokeWidth={2} />
                    <Line type="monotone" dataKey="RMS Velocity z-axis" stroke="#A833FF" strokeWidth={2} />
                </LineChart>
            </ResponsiveContainer>
        );
    };

    const isUpdateAccepted = updateRespData?.response === "Y";
    const isUpdateRejected = updateRespData?.response === "N";

    return (
        <div className='main'>
            <div className='icon-block'>
                <h5>{format(selectedToDate, "MMMM d, yyyy")}</h5>
                <hr></hr>
                <h4>{machineDetails.Client_Name !== undefined ? machineDetails.Client_Name : <div style={{ width: 100, height: 20 }}><Skeleton /></div>}</h4>
                <hr></hr>
                <h4>{machineDetails.Machine_Serial_Number !== undefined ? machineDetails.Machine_Serial_Number : <div style={{ width: 100 }}><Skeleton /></div>}</h4>
                <hr></hr>
                <i class="fa fa-bell-o" onClick={() => { setIsNotificationOpen(!isNotificationOpen) }}>
                    {alarmCount === 0 ? <></> :
                        <span style={{
                            position: 'absolute',
                            // top: '0',
                            // right: '40px',
                            backgroundColor: 'red',
                            color: 'white',
                            borderRadius: '50%',
                            padding: '3px 6px',
                            fontSize: '12px',
                            margin: "-10px -3px "
                        }}>
                            {alarmCount}
                        </span>
                    }
                </i>
                <hr></hr>
                <i class="fa fa-info-circle" onClick={toggleDetails}></i>
            </div>

            {isDetailOpen && (
                <div className="profile-overlay" onClick={closeProfile}>
                    <div className="profile-panel" onClick={(e) => e.stopPropagation()}>
                        <div style={{ justifyContent: "space-between", display: 'inline-flex', alignItems: "center" }}>
                            <h3>Machine Details</h3>
                            <i class="fa-solid fa-xmark" style={{ marginRight: 10 }} onClick={toggleDetails}></i>
                        </div>
                        {Object.entries(machineDetails).length ?
                            <div className='machine-details-box'>
                                {Object.entries(machineDetails).map(([key, value]) => (
                                    <div key={key} className="details">
                                        <span className="detail-key">{key.replace(/_/g, ' ')}:</span>
                                        <span className="detail-value">{value}</span>
                                    </div>
                                ))}
                            </div>
                            :
                            <div style={{ width: "100%", marginTop: 20 }}>
                                <Skeleton count={10} />
                            </div>
                        }
                    </div>
                </div>
            )}

            {isNotificationOpen && (
                <div className="profile-overlay" onClick={closeProfile}>
                    <div className="profile-panel" onClick={(e) => e.stopPropagation()} style={{ height: "100vh" }}>
                        <div className='icon-block' style={{ justifyContent: "space-between" }}>
                            <h3>Alarms</h3>
                            <i class="fa-solid fa-xmark" onClick={() => { setIsNotificationOpen(!isNotificationOpen) }}></i>
                        </div>
                        {notificationData.length ?
                            <div style={{ height: "90vh", overflowY: "scroll", scrollbarWidth: "none", }}>
                                {notificationData.map((item, index) => (
                                    <div key={index}
                                        style={{
                                            width: "98",
                                            margin: "1%",
                                            backgroundColor: (item.value === "OFF" ? "#cbedd6" : "#f9d4d4"),
                                            padding: "2px 10px",
                                            color: (item.value === "OFF" ? "green" : "red"),
                                            borderRadius: 5,
                                        }}>
                                        <span >{item.name}</span>
                                    </div>
                                ))}
                            </div>
                            :
                            <div style={{ width: "100%", marginTop: 20 }}>
                                <h2>No Active Alarms</h2>
                            </div>
                        }


                    </div>
                </div>
            )}

            {updateRespData && (isUpdateAccepted || isUpdateRejected) && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(15, 23, 42, 0.45)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 2000,
                    }}
                >
                    <div
                        style={{
                            width: 360,
                            maxWidth: "90vw",
                            backgroundColor: "white",
                            borderRadius: 14,
                            padding: "28px 26px 22px",
                            textAlign: "center",
                            boxShadow: "0 20px 45px rgba(0, 0, 0, 0.25)",
                            animation: "popIn 0.18s ease-out",
                        }}
                    >
                        <div
                            style={{
                                width: 64,
                                height: 64,
                                borderRadius: "50%",
                                backgroundColor: isUpdateAccepted ? "#e6f7ec" : "#fdeaea",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "0 auto 18px",
                            }}
                        >
                            <i
                                className={isUpdateAccepted ? "fa fa-check" : "fa fa-times"}
                                style={{
                                    fontSize: 26,
                                    color: isUpdateAccepted ? "#28a745" : "#dc3545",
                                }}
                            ></i>
                        </div>

                        <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 8px", color: "#1f2937" }}>
                            {isUpdateAccepted ? "Accepted on Machine" : "Rejected on Machine"}
                        </h2>

                        <p style={{ fontSize: 13.5, color: "#6b7280", margin: "0 0 22px", lineHeight: 1.5 }}>
                            {isUpdateAccepted
                                ? "The batch data was accepted and applied on the machine."
                                : "The machine rejected the batch data update. Please review the values and try again."}
                        </p>

                        <button
                            onClick={handleAckUpdateResp}
                            disabled={ackLoading}
                            style={{
                                backgroundColor: isUpdateAccepted ? "#28a745" : "#dc3545",
                                color: "white",
                                border: "none",
                                padding: "10px 40px",
                                borderRadius: 8,
                                fontSize: 14,
                                fontWeight: 600,
                                cursor: ackLoading ? "not-allowed" : "pointer",
                                opacity: ackLoading ? 0.7 : 1,
                                transition: "opacity 0.2s ease",
                            }}
                        >
                            {ackLoading ? "Please wait..." : "OK"}
                        </button>
                    </div>
                </div>
            )}


            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                <div className="card-container-block" style={{ backgroundColor: (machineState) }}>
                    {data.length ?
                        <div className="card-container">
                            {data.map((item, index) => (
                                <div key={index}>
                                    {item.type === 1 ?
                                        <div className="card1">
                                            <i class={item.icon}></i>
                                            <h3 style={{ fontSize: 16, color: "darkslategray", fontWeight: 700 }}>{item.value}</h3>
                                            <p style={{ fontSize: 13, color: "black", fontWeight: 400 }}>{item.title}</p>
                                            <div className='progressBar'>
                                                <div className='progressBar-filed' style={{ backgroundColor: item.color }}></div>
                                            </div>
                                        </div>
                                        :
                                        <div className="card1" style={{ backgroundColor: item.color }}>
                                            <i style={{ color: "white" }} class={item.icon}></i>
                                            <h3 style={{ fontSize: 16, fontWeight: 700, color: "white" }}>{item.value}</h3>
                                            <p style={{ fontSize: 13, fontWeight: 400, color: "white" }}>{item.title}</p>
                                            <div className='progressBar'>
                                                <div className='progressBar-filed' style={{ backgroundColor: 'white' }}></div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            ))}
                        </div>
                        :
                        <div style={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '10px',
                            justifyContent: 'space-evenly',
                            margin: '5px 0'
                        }}>
                            {Array.from({ length: 8 }).map((_, index) => (
                                <div
                                    style={{
                                        flexBasis: '22%', // Ensures 4 items per row with spacing
                                        height: '100px'
                                    }}
                                    key={index}
                                >
                                    <Skeleton count={3} />
                                </div>
                            ))}
                        </div>

                    }
                    {
                        actualBatchData.length ?
                            <div className='card2'>
                                {actualBatchData.map((item, index) => (
                                    <div className="cardActual" key={index}>
                                        <div style={{ backgroundColor: item.color, padding: 5, borderRadius: 5 }}>
                                            <i style={{ color: "white" }} class={item.icon}></i>
                                        </div>
                                        <div>
                                            <h3 style={{ fontSize: 16, color: "darkslategray", fontWeight: 700 }}>{item.value}</h3>
                                            <p style={{ fontSize: 13, color: "black", fontWeight: 400 }}>{item.title}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            :
                            <div style={{
                                width: '100%',
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '10px',
                                justifyContent: 'space-evenly',
                                margin: '5px 0'
                            }}>
                                {Array.from({ length: 4 }).map((_, index) => (
                                    <div
                                        style={{
                                            flexBasis: '22%', // Ensures 4 items per row with spacing
                                            height: '100px'
                                        }}
                                        key={index}
                                    >
                                        <Skeleton count={3} />
                                    </div>
                                ))}
                            </div>
                    }
                </div>

                <div style={{ width: "35%", margin: "5px", justifyContent: "space-between" }}>
                    <div style={{ backgroundColor: "white", borderRadius: 10, height: "fit-content" }}>
                        <div className='dashboard-header ' style={{ justifyContent: "center", alignItems: "flex-start", borderRadius:10 }}>
                            <div className='speedometer-box'>
                                <h5>Hydraulic indicator</h5>
                                <LevelIndicator value={visualData.Hhydraulic_Level_Indicator} />
                            </div>
                            <div className='speedometer-box'>
                                <h5>Hydraulic Temp</h5>
                                <Thermometer temperature={visualData.Hhydraulic_Temprature} />
                            </div>
                            <div className='speedometer-box'>
                                <h5>Gear Box Temp</h5>
                                <Thermometer temperature={visualData.Gear_Box_Temprature == 'NaN' ? 0 : visualData.Gear_Box_Temprature} />
                            </div>
                        </div>
                    </div>
                    <div style={{ width: "100%", backgroundColor: 'pink', marginTop: 10, borderRadius: 10 }} className='electric-block'>
                        <h3 style={{ padding: "10px 0 0 0", margin: 0, fontSize: 15, fontWeight: 700 }}>Electrical Consumption Monitoring</h3>
                        <div style={{ justifyContent: "space-between", alignContent: "center", width: '100%' }}>
                            {electricSpec.length ?
                                <div>
                                    {
                                        electricSpec.map((item, index) => (
                                            <div key={index} style={{ width: '33%', margin: " 0", borderRadius: 10, padding: "3px 0", display: "inline-flex", flexDirection: 'row', justifyContent: "space-evenly" }}>
                                                <div style={{ width: "100%" }} className='electric-card'>
                                                    <p style={{ fontSize: 12 }}>{item.title}</p>
                                                    <h2>{item.value.toFixed(2)} </h2>
                                                </div>
                                                {(index === Object.keys(electricSpec).length - 1) ? <></> : <hr style={{ borderLeft: "0.5px solid grsy" }}></hr>}

                                            </div>
                                        ))
                                    }
                                </div>
                                :
                                <div style={{ width: '100%', display: 'flex', gap: '10px', justifyContent: "space-evenly", margin: "10px 0" }}>
                                    {Array.from({ length: 3 }).map((_, index) => (
                                        <div style={{ width: "30%" }} key={index} >
                                            <Skeleton count={2} />
                                        </div>
                                    ))}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ display: "inline-flex", flexDirection: 'row', alignItems: "center", justifyContent: "space-between", width: "98%", margin: "0 1%" }}>


                <div style={{ width: "25%", height: "250px", marginTop: 5, padding: 10 }}>
                    <table style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontFamily: "Arial, sans-serif",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                        overflow: "hidden"
                    }}>
                        {/* Table Header */}
                        <thead>
                            <tr style={{
                                backgroundColor: "#6f6fa3",
                                color: "white",
                                textAlign: "left",
                                fontSize: "16px"
                            }}>
                                <th style={{ padding: "10px" }}>Cutting Parameters</th>
                                <th style={{ padding: "10px" }}>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rawData.map((item, rowIndex) => (
                                Object.entries(item).map(([key, value], idx) => (
                                    <tr
                                        key={`${rowIndex}-${idx}`}
                                        style={{
                                            backgroundColor: idx % 2 === 0 ? "#f5f5f5" : "white",
                                            transition: "background 0.3s",
                                            cursor: "pointer",
                                        }}
                                        onMouseEnter={(e) =>
                                            (e.currentTarget.style.backgroundColor = "#dfe6e9")
                                        }
                                        onMouseLeave={(e) =>
                                        (e.currentTarget.style.backgroundColor =
                                            idx % 2 === 0 ? "#f5f5f5" : "white")
                                        }
                                    >
                                        <td style={{ padding: "10px", fontSize: "14px", textTransform:"capitalize" }}>
                                            {key.replace(/_/g, " ")}
                                        </td>
                                        <td style={{ padding: "10px", fontSize: "14px" }}>{value}</td>
                                    </tr>
                                ))
                            ))}

                        </tbody>
                    </table>
                </div>
                <div style={{ width: "15%", height: "250px", marginTop: 5, padding: 10 }}>
                    {/* <table >
                        <thead>
                            <tr>
                                <th>Blade</th>
                                <th>Life</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td >{"blade 1"}</td>
                                <td >{bladeData.length ? bladeData[0].blade_1 : 0}</td>
                            </tr>
                            <tr>
                                <td>{"blade 2"}</td>
                                <td>{bladeData.length ? bladeData[0].blade_2 : 0}</td>
                            </tr>
                            <tr>
                                <td>{"blade 3"}</td>
                                <td>{bladeData.length ? bladeData[0].blade_3 : 0}</td>
                            </tr>
                            <tr>
                                <td>{"blade 4"}</td>
                                <td>{bladeData.length ? bladeData[0].blade_4 : 0}</td>
                            </tr>
                            <tr>
                                <td>{"blade 5"}</td>
                                <td>{bladeData.length ? bladeData[0].blade_5 : 0}</td>
                            </tr>
                        </tbody>
                    </table> */}
                    <table style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontFamily: "Arial, sans-serif",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                        overflow: "hidden"
                    }}>
                        {/* Table Header */}
                        <thead>
                            <tr style={{
                                backgroundColor: "#6f6fa3",
                                color: "white",
                                textAlign: "left",
                                fontSize: "16px"
                            }}>
                                <th style={{ padding: "10px" }}>Blade</th>
                                <th style={{ padding: "10px" }}>Life</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[1, 2, 3, 4, 5].map((num, index) => (
                                <tr key={num}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? "#f5f5f5" : "white",
                                        transition: "background 0.3s",
                                        cursor: "pointer"
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#dfe6e9"}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#f5f5f5" : "white"}
                                >
                                    <td style={{ padding: "10px", fontSize: "14px" }}>{`Blade ${num}`}</td>
                                    <td style={{ padding: "10px", fontSize: "14px" }}>{bladeData.length ? bladeData[0][`blade_${num}`] : 0}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>


                </div>

                <div style={{ width: "30%", height: "250px", marginTop: 5, padding: 10 }}>
                    <table style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontFamily: "Arial, sans-serif",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                        overflow: "hidden"
                    }}>
                        {/* Table Header */}
                        <thead>
                            <tr style={{
                                backgroundColor: "#6f6fa3",
                                color: "white",
                                textAlign: "left",
                                fontSize: "16px"
                            }}>
                                <th style={{ padding: "10px" }}>Batch</th>
                                <th style={{ padding: "10px" }}>Set qty</th>
                                <th style={{ padding: "10px" }}>Cut Length</th>
                                <th style={{ padding: "10px" }}>Actual qty</th>
                            </tr>
                        </thead>
                        <tbody>
                            {batchData.map((item, index) => (
                                <tr key={index}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? "#f5f5f5" : "white",
                                        transition: "background 0.3s",
                                        cursor: "pointer"
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#dfe6e9"}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#f5f5f5" : "white"}
                                >
                                    <td style={{ padding: "10px", fontSize: "14px" }}>B {index + 1}</td>
                                    <td style={{ padding: "10px", fontSize: "14px" }}>{item.set_quantity}</td>
                                    <td style={{ padding: "10px", fontSize: "14px" }}>{item.cut_length}</td>
                                    <td style={{ padding: "10px", fontSize: "14px" }}>{item.actual_quantity}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className='line-graph-container' style={{ width: "40%", height: "250px", backgroundColor: "white", borderRadius: 10, marginLeft: 20, padding: 10, marginTop: 10 }}>
                    <div style={{ width: "100%" }}>
                        <h5 style={{ textAlign: "center" }}>Acceleration Graph</h5>
                        {MultiLineChartAcc()}
                    </div>
                    <div style={{ width: "100%" }}>
                        <h5 style={{ textAlign: "center" }}>Velocity Graph</h5>
                        {MultiLineChartVel()}
                    </div>
                </div>
            </div>



            <div className='powered'>
                <i class="fa fa-copyright" style={{ fontSize: 10 }}></i>
                <p >Powered by</p>
                <img style={{ width: "20px", margin: "0  0 0 5px" }}
                    src={require("../Assets/new_logo.png")}
                    alt="logo"
                />
                <p style={{ margin: 0, fontWeight: 600 }}>SuperManager</p>
            </div>

        </div>
    )
}

export default Dashboard